import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import { useGetUsersQuery } from "../services/userService";
import { getUsersColumns } from "../data/users";
import UserFormModal from "../components/UserFormModal";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [user, setUser] = useState(null);

  const {
    data: users,
    error,
    isFetching,
    refetch,
  } = useGetUsersQuery({ page: 1, pageSize: 10 });

  const handleAddSuccess = () => {
    refetch();
    setIsModalOpen(false);
  };

  if (isFetching) return <div>Loading...</div>;

  if (error) return <div>Error fetching users</div>;

  const handleView = (user: any) => {
    navigate(`/users/${user._id}`);
  };

  const handleEdit = (user: any) => {
    setUser(user);
    setIsModalOpen(true);
  };

  const handleDelete = (user: any) => {};

  const columns = getUsersColumns(handleView, handleEdit, handleDelete);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            // Handle add user logic here
            setIsModalOpen(true);
          }}
        >
          Add User
        </Button>
      </Box>
      <DataGrid
        rows={users?.users || []}
        columns={columns}
        getRowId={(row) =>
          row._id || Math.random().toString(36).substring(2, 9)
        }
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-cell": {
            padding: "8px 16px",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#f5f5f5",
          },
        }}
      />

      {/* Add/Edit User Modal */}
      <UserFormModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleAddSuccess}
        user={user}
      />
    </Box>
  );
};

export default Users;
